export default "__VITE_ASSET__eZmTQxEu__"